module.exports = __webpack_public_path__ + "images/chrome.jpg?b9ecc6de190649522cecc8810b2f2574";